import { adminRoute } from "@/routes/admin/admin.route";
import { collectionsRoute } from "@/routes/collections/collections.route";
import { homeRoute } from "@/routes/home/home.route";
import { indexRoute } from "@/routes/index.route";
import { fileExplorerRoute } from "@/routes/file-explorer/file-explorer.route";
import { loginRoute } from "@/routes/login/login.route";
import { unauthorizedRoute } from "@/routes/unauthorized/unauthorized.route";
import { rootRoute } from "@/routes/root";

export const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  unauthorizedRoute,
  homeRoute,
  collectionsRoute,
  adminRoute,
  fileExplorerRoute,
]);
